const defaults = {
  invalid: '#d9d9d9',
  white: '#FFFFFF',
  gray1: '#FEFEFE',
  gray2: '#F2F2F2',
  gray3: '#E6E6E6',
  gray4: '#D9D9D9',
  gray5: '#BFBFBF',
  gray6: '#A6A6A6',
  gray7: '#8C8C8C',
  gray8: '#737373',
  gray9: '#595959',
  gray10: '#404040',
  gray11: '#262626',
  gray12: '#1A1A1A',
  gray13: '#0C0C0C',
  near_black: '#0C0C0C',
};

const cnn_red = [
  ['#cc0000'],
  ['#f18469', '#9d1306'],
  ['#f9a38d', '#d93e24', '#751708'],
  ['#fdb5a3', '#e96a4d', '#bf0802', '#5e1608'],
  ['#fec2b2', '#f18469', '#d93e24', '#9d1306', '#4f1507'],
  ['#ffcbbd', '#f6967d', '#e55e42', '#cd0602', '#861608', '#451407'],
  ['#ffd1c5', '#f9a38d', '#ec7458', '#d93e24', '#b20d04', '#751708', '#3d1306'],
];

const red = [
  ['#ff3f3f'],
  ['#ff7a6c', '#8e2c27'],
  ['#ffa091', '#dc3a38', '#6a241f'],
  ['#ffb4a7', '#ff544d', '#ac312e', '#551f1a'],
  ['#ffc1b6', '#ff7a6c', '#dc3a38', '#8e2c27', '#471c17'],
  ['#ffcac0', '#ff9081', '#fe3f3f', '#ba3430', '#792723', '#3e1915'],
  ['#ffd1c8', '#ffa091', '#ff6459', '#dc3a38', '#a12f2b', '#6a241f', '#371713'],
];

const orange = [
  ['#ff7c00'],
  ['#ff7e0a', '#7a3f11'],
  ['#ffa35c', '#bb5d0e', '#5b3011'],
  ['#ffb77f', '#e47007', '#934a11', '#4a2810'],
  ['#ffc495', '#ff7e0a', '#bb5d0e', '#7a3f11', '#3e220e'],
  ['#ffcda5', '#ff9441', '#d86a0a', '#9f5011', '#683611', '#361e0d'],
  ['#ffd3b0', '#ffa35c', '#ef7505', '#bb5d0e', '#8a4611', '#5b3011', '#311c0c'],
];

const yellow = [
  ['#f0b100'],
  ['#cf990c', '#644a14'],
  ['#ecae02', '#987114', '#4b3813'],
  ['#f7bd45', '#b98911', '#785915', '#3d2e11'],
  ['#fcc866', '#cf990c', '#987114', '#644a14', '#342710'],
  ['#fecf7d', '#e0a507', '#af8212', '#816015', '#564014', '#2d230f'],
  ['#ffd58e', '#ecae02', '#c18f10', '#987114', '#705415', '#4b3813', '#291f0d'],
];

const green = [
  ['#4bc88a'],
  ['#46b67e', '#29573f'],
  ['#5fcd94', '#38855d', '#214230'],
  ['#84d8a9', '#40a271', '#2f694b', '#1d3528'],
  ['#9adfb7', '#46b67e', '#38855d', '#29573f', '#1a2d22'],
  ['#a9e3c1', '#4ac488', '#3e9a6b', '#327150', '#254b36', '#17281e'],
  ['#b4e7c8', '#5fcd94', '#43a976', '#38855d', '#2d6246', '#214230', '#15241b'],
];

const teal = [
  ['#60b9b1'],
  ['#5cb0a8', '#315551'],
  ['#7fc5be', '#46817b', '#27403d'],
  ['#9ad1cb', '#539d96', '#3a6662', '#213432'],
  ['#abd9d3', '#5cb0a8', '#46817b', '#315551', '#1d2c2a'],
  ['#b7deda', '#6abdb5', '#4f958e', '#3d6e69', '#2b4946', '#1a2725'],
  ['#c0e2de', '#7fc5be', '#56a49d', '#46817b', '#365f5b', '#27403d', '#182321'],
];

const blue = [
  ['#3061f2'],
  ['#9799f9', '#2e45a7'],
  ['#b4b1fb', '#4c6af3', '#28357b'],
  ['#c4c1fc', '#7e86f7', '#3053cd', '#242b61'],
  ['#cecbfd', '#9799f9', '#4c6af3', '#2e45a7', '#202551'],
  ['#d5d2fd', '#a8a7fa', '#717ef6', '#3059dd', '#2b3c8e', '#1e2146'],
  ['#dbd8fd', '#b4b1fb', '#888df7', '#4c6af3', '#2f4ebf', '#28357b', '#1b1e3d'],
];

const purple = [
  ['#9656d1'],
  ['#bd90e2', '#643c88'],
  ['#cfabe9', '#9859d2', '#4b2e65'],
  ['#d9bcee', '#af7adb', '#7947a6', '#3d2650'],
  ['#dfc7f1', '#bd90e2', '#9859d2', '#643c88', '#342143'],
  ['#e4cff3', '#c79fe6', '#a871d9', '#824bb3', '#563474', '#2d1e3a'],
  ['#e7d5f4', '#cfabe9', '#b482de', '#9859d2', '#71429b', '#4b2e65', '#281b33'],
];

const pink = [
  ['#fc2f59'],
  ['#ff7783', '#912636'],
  ['#ff9ea2', '#e02e50', '#6c212a'],
  ['#ffb3b5', '#ff5169', '#b02a40', '#561d23'],
  ['#ffc0c1', '#ff7783', '#e02e50', '#912636', '#491a1e'],
  ['#ffc9ca', '#ff8e95', '#fe3c5e', '#be2b45', '#7b232f', '#3f181b'],
  ['#ffd0d1', '#ff9ea2', '#ff6173', '#e02e50', '#a4293c', '#6c212a', '#381618'],
];


const gray = [
  ['#737373'],
  ['#a2a2a2', '#4e4e4e'],
  ['#b9b9b9', '#777777', '#3b3b3b'],
  ['#c6c6c6', '#919191', '#5e5e5e', '#303030'],
  ['#d0d0d0', '#a2a2a2', '#777777', '#4e4e4e', '#292929'],
  ['#d6d6d6', '#afafaf', '#898989', '#656565', '#434343', '#242424'],
  ['#dbdbdb', '#b9b9b9', '#979797', '#777777', '#585858', '#3b3b3b', '#212121'],
];

const politics = {
  rep: [
    ['#ff4a43'],
    ['#ff7a6a', '#8b2f28'],
    ['#ffa090', '#d6413a', '#672620'],
    ['#ffb4a6', '#ff544a', '#a8372f', '#53211b'],
    ['#ffc1b5', '#ff7a6a', '#d6413a', '#8b2f28', '#461d18'],
    ['#ffcac0', '#ff9080', '#f84941', '#b53a32', '#762a24', '#3d1a16'],
    ['#ffd1c8', '#ffa090', '#ff6456', '#d6413a', '#9d342d', '#672620', '#361814'],
  ],
  dem: [
    ['#1a6aff'],
    ['#8f9aff', '#2647a5'],
    ['#afb2ff', '#286cff', '#243679'],
    ['#c0c1ff', '#7187ff', '#2556ca', '#212c60'],
    ['#cbcbff', '#8f9aff', '#286cff', '#2647a5', '#1e2650'],
    ['#d3d2ff', '#a2a8ff', '#627fff', '#235cda', '#253d8c', '#1c2145'],
    ['#d9d8ff', '#afb2ff', '#7d8eff', '#286cff', '#2650bc', '#243679', '#1a1e3d'],
  ],
  lib: [
    ['#ffc61c'],
    ['#c99c1e', '#614c18'],
    ['#e4b11e', '#93721d', '#493915'],
    ['#f5bf1d', '#b38b1e', '#745b1a', '#3b2f13'],
    ['#ffc82c', '#c99c1e', '#93721d', '#614c18', '#322812'],
    ['#ffd158', '#d8a81e', '#aa841e', '#7d611b', '#534117', '#2c2310'],
    ['#ffd771', '#e4b11e', '#bb911e', '#93721d', '#6d551a', '#493915', '#28200f'],
  ],
  green: [
    ['#24cf54'],
    ['#26ba4d', '#20592a'],
    ['#41d35f', '#26883b', '#1c4321'],
    ['#74dd80', '#27a646', '#236c30', '#19371c'],
    ['#8ee395', '#26ba4d', '#26883b', '#20592a', '#172e19'],
    ['#a0e7a4', '#25c952', '#279d42', '#247433', '#1e4d25', '#152916'],
    ['#aceaaf', '#41d35f', '#27ae48', '#26883b', '#22652e', '#1c4321', '#142415'],
  ],
  other: [
    ['#2bbcd9'],
    ['#2cb1cc', '#235561'],
    ['#60c6df', '#2a8194', '#1e4048'],
    ['#87d2e5', '#2c9db5', '#266675', '#1b343a'],
    ['#9dd9ea', '#2cb1cc', '#2a8194', '#235561', '#182c31'],
    ['#acdfed', '#39beda', '#2b95ac', '#286e7e', '#204953', '#16272b'],
    ['#b7e3ef', '#60c6df', '#2ca5be', '#2a8194', '#25606d', '#1e4048', '#152326'],
  ],
  // sentiment
  pos: [
    ['#38ba79'],
    ['#38b777', '#25583c'],
    ['#71cb97', '#2f8659', '#1f422e'],
    ['#90d6ab', '#34a36b', '#296a47', '#1b3626'],
    ['#a3ddb9', '#38b777', '#2f8659', '#25583c', '#182e21'],
    ['#b0e2c2', '#59c388', '#339b66', '#2b724c', '#214b34', '#16281d'],
    ['#bae5ca', '#71cb97', '#36ab70', '#2f8659', '#276343', '#1f422e', '#14241a'],
  ],
  neg: [
    ['#ff7c05'],
    ['#ff7e0e', '#7a3f12'],
    ['#ffa35d', '#bb5d11', '#5b3011'],
    ['#ffb780', '#e4700b', '#934a12', '#4a2810'],
    ['#ffc496', '#ff7e0e', '#bb5d11', '#7a3f12', '#3e220f'],
    ['#ffcca5', '#ff9442', '#d86a0d', '#9f5012', '#683612', '#361e0d'],
    ['#ffd3b1', '#ffa35d', '#ef7509', '#bb5d11', '#8a4612', '#5b3011', '#311c0c'],
  ],
};

const business = {
  green: [
    ['#00c59e'],
    ['#0cb793', '#1c5848'],
    ['#4ccdaa', '#1c866c', '#194237'],
    ['#79d8bb', '#16a383', '#1d6a56', '#17362d'],
    ['#92dfc6', '#0cb793', '#1c866c', '#1c5848', '#152e26'],
    ['#a2e4ce', '#0fc69f', '#189b7d', '#1d725c', '#1b4b3e', '#142822'],
    ['#afe7d4', '#4ccdaa', '#13ab89', '#1c866c', '#1d6351', '#194237', '#13241e'],
  ],
  redorange: [
    ['#ff5037'],
    ['#ff7b5f', '#893222'],
    ['#ffa088', '#d44530', '#66281c'],
    ['#ffb5a0', '#ff553b', '#a63928', '#522218'],
    ['#ffc2b0', '#ff7b5f', '#d44530', '#893222', '#451e15'],
    ['#ffcbbb', '#ff9177', '#f54e35', '#b33d2a', '#752c1f', '#3c1b13'],
    ['#ffd1c4', '#ffa088', '#ff6549', '#d44530', '#9b3626', '#66281c', '#351812'],
  ],
  night: [
    ['#004969'],
    ['#91a5b6', '#1e5372'],
    ['#acbbc8', '#5b7b93', '#093f5b'],
    ['#bcc8d3', '#7b94a8', '#39637f', '#0f3448'],
    ['#c7d1da', '#91a5b6', '#5b7b93', '#1e5372', '#102c3d'],
    ['#cfd7df', '#a0b1c0', '#728ca2', '#436985', '#014868', '#102635'],
    ['#d5dce3', '#acbbc8', '#839aad', '#5b7b93', '#305d7a', '#093f5b', '#10222f'],
  ],
  sky: [
    ['#00bcf0'],
    ['#0fafdf', '#205469'],
    ['#55c5f2', '#2080a2', '#1c3f4e'],
    ['#82d1f5', '#199cc7', '#21657f', '#1a343f'],
    ['#9ad8f7', '#0fafdf', '#2080a2', '#205469', '#172c35'],
    ['#aadef8', '#17bdf0', '#1c94bc', '#216d89', '#1e485a', '#16262e'],
    ['#b6e2f9', '#55c5f2', '#16a3d0', '#2080a2', '#215f77', '#1c3f4e', '#142229'],
  ],
  salmon: [
    ['#ff6674'],
    ['#ff7881', '#7f383d'],
    ['#ff9ea1', '#c4515b', '#5f2c2f'],
    ['#ffb3b4', '#f0616e', '#9a4249', '#4c2527'],
    ['#ffc0c0', '#ff7881', '#c4515b', '#7f383d', '#402021'],
    ['#ffc9c9', '#ff8e93', '#e35c68', '#a6464e', '#6c3135', '#381d1d'],
    ['#ffd0d0', '#ff9ea1', '#fb6572', '#c4515b', '#903e44', '#5f2c2f', '#311a1b'],
  ],
  gray: [
    ['#a3a3a3'],
    ['#a2a2a2', '#4e4e4e'],
    ['#b9b9b9', '#777777', '#3b3b3b'],
    ['#c6c6c6', '#919191', '#5e5e5e', '#303030'],
    ['#d0d0d0', '#a2a2a2', '#777777', '#4e4e4e', '#292929'],
    ['#d6d6d6', '#afafaf', '#898989', '#656565', '#434343', '#242424'],
    ['#dbdbdb', '#b9b9b9', '#979797', '#777777', '#585858', '#3b3b3b', '#212121'],
  ],
};

export {
  defaults,
  business,
  politics,
  cnn_red,
  red,
  orange,
  yellow,
  green,
  teal,
  blue,
  purple,
  pink,
  gray,
};
